var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"blocks",style:({ background: _vm.bg_color }),attrs:{"id":"block7"}},[_c('div',{staticClass:"container"},[_c('h2',{staticClass:"title-box"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('article',{domProps:{"innerHTML":_vm._s(_vm.content)}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-37e80e1f","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/blocks/Block7.vue
// module id = 82
// module chunks = 0